import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[dbxFocus]',
  standalone: true,
})
export class FocusDirective implements AfterViewInit {
  element = inject(ElementRef);

  ngAfterViewInit() {
    // Defer focus to next microtask to avoid ExpressionChangedAfterItHasBeenCheckedError
    requestAnimationFrame(() => this.element.nativeElement.focus());
  }
}
